"use strict";

import Vue from 'vue';

Vue.filter('number', function(value, decimalParam) {
  var accounting = require("accounting");
  var decimal = typeof(decimalParam) !== 'undefined' ? decimalParam : 2;
  decimal = value == 0 ? 0 : decimal;
  if(value == '-') {
    return value
  }
  // if(value > 100){
  //   return accounting.formatNumber(parseFloat(value), ',');
  // }
  return accounting.formatNumber(parseFloat(value), decimal, ',');
})

Vue.filter('odd', function(value, decimalParam) {
  return parseFloat(value).toFixed(2);
})

Vue.filter('ccl', function(value, decimalParam) {
  var accounting = require("accounting");
  if(value){
    var decimal = typeof(decimalParam) !== 'undefined' ? decimalParam : 2;
    if(window.account._showDecimals){
      if(typeof(value) === "string"){
        value = parseFloat(value.split(',').join(''))
      }
    }else{
      if(typeof(value) == "string"){
        value = Math.floor(parseFloat(value.split(',').join('')))
      }else if(typeof(value) === "number"){
        value = Math.floor(value)
      }
    }
    decimal = value == 0 ? 0 : decimal;
    if(value == '-') {
      return value
    }
  }
  return accounting.formatNumber(Math.floor((value*100).toFixed(2))/100, decimal, ',');
})

Vue.filter('roundUpNumber', function(value, isRoundUp) {
  if(value == '-') {
    return value
  }

  var accounting = require("accounting");
  var decimal = 0;

  isRoundUp = typeof(isRoundUp) === 'undefined' ? true : isRoundUp;

  value = isRoundUp ? Math.ceil(parseFloat(value)) : Math.floor(parseFloat(value))

  return accounting.formatNumber(value, decimal, ',');
})

Vue.filter('kSeperator', function(value) {
  if(value == '-' || value == 0) {
    return '-'
  }
  value = value.toString()
  if(value.length > 3) {
    return value.substr(0, value.length -3)  + 'k'
  } else {
    return value
  }
})

Vue.filter('decimal', function(value, decimalParam) {
  var accounting = require("accounting");
  var decimal = typeof(decimalParam) !== 'undefined' ? decimalParam : 2;
  //decimal = value == 0 ? 0 : decimal;
  if(value == '-') {
    return value
  }
  // if(value > 100){
  //   return accounting.formatNumber(parseFloat(value), ',');
  // }
  return accounting.formatNumber(parseFloat(value), decimal, ',');
})


// WEBPACK FOOTER //
// ./resources/wob/vue/filters/vue-filter-number.js